import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import YearGroupInsights from "./routes/YearGroupInsights";

export default store => ({
  path: "year-group",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "year-group" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [YearGroupInsights(store)],
});
